export const formatDate = (dateVal) => {
  const date = new Date(dateVal);
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const monthIndex = date.getUTCMonth();
  return `${months[monthIndex]} ${date.getUTCDate()}, ${date.getUTCFullYear()}`;
};
